<template>
  <b-row class="">
    <b-col class="b-avatar-img mb-5 col-md-12 col-12">
      <div class="position-absolute tt-alert-block">
        <transition
          name="alert-slide-fade"
          leave-active-class="animate__animated animate__fadeOutUp"
        >
          <b-alert
            variant="success"
            size="lg"
            show
            v-if="deletingStatus === 'successDeletion'"
            >Place was deleted successfully</b-alert
          >
        </transition>
        <transition
          name="alert-slide-fade"
          leave-active-class="animate__animated animate__fadeOutUp"
        >
          <b-alert
            variant="danger"
            size="lg"
            show=""
            v-if="deletingStatus === 'failedDeletion'"
            >There was a problem deleting the place please try again.</b-alert
          >
        </transition>
      </div>
      <div v-if="!limit && savedPlaces.length > 0">
        <div>
          <h1 class="font-weight-500 text-center mb-0 mt-3">Locations</h1>
        </div>
      </div>
      <div class="mt-md-0 mb-5 tt-mt" :class="{ 'tt-mt': !limit }">
        <hr class="mb-4" v-if="!limit" />
        <b-col
          class="px-0 justify-content-center text-center d-flex"
          v-if="!limit"
        >
          <b-button
            :to="'/add-place'"
            variant="warning"
            class="w-100 py-2 btn-new text-white mb-3 tt-border-radius"
            >Add a new location</b-button
          >
        </b-col>
        <b-list-group class="tt-border-radius">
          <b-list-group-item
            class="text-left bg-primary text-white tt-border-radius"
            v-if="savedPlaces.length > 0"
          >
            <div class="d-flex justify-content-between">
              <span>Your Locations</span>
            </div>
          </b-list-group-item>
          <template>
            <b-list-group-item
              class="text-left tt-border-radius"
              v-for="place in savedPlaces"
              :class="{
                'd-none': place.is_default === true
              }"
              :key="place._id"
            >
              <div class="row">
                <div class="col-9 col-md-8 text-left">
                  <div class="d-flex mr-2">
                    <div>
                      <b-icon
                        icon="exclamation-circle-fill"
                        variant="warning"
                        v-if="!place.is_synced && !place.is_default"
                        class="mr-2"
                      ></b-icon>
                      <b-icon
                        icon="check-circle-fill"
                        variant="success"
                        v-else
                        class="mr-2"
                      ></b-icon>
                    </div>
                    <div>
                      <span>{{ place.name }}</span
                      ><br />
                      <small>{{ place.extra }}</small>
                      <small>
                        <span v-if="place.is_business === 1" class="mb-0"
                          >Business related</span
                        >
                        <span v-if="place.is_business === 0" class="mb-0"
                          >Private</span
                        >
                        <div>{{ place.vehicle }}</div>
                      </small>
                    </div>
                  </div>
                </div>
                <div class="col-3 col-md-4" v-if="!place.is_default">
                  <div class="d-flex" style="justify-content: end">
                    <b-icon
                      icon="pencil"
                      scale="1"
                      class="mr-2"
                      @click="editPlace(place)"
                    ></b-icon>
                    <b-icon
                      icon="x-circle-fill"
                      scale="1"
                      variant="danger"
                      v-b-modal.modal-center
                      modal-ok.delete
                      @click="selectedPlace = place"
                    ></b-icon>
                  </div>
                </div>
              </div>
            </b-list-group-item>
          </template>
        </b-list-group>
      </div>
    </b-col>
    <b-modal
      id="modal-center"
      centered
      title="Delete"
      header-bg-variant="tt-bg"
    >
      <template>
        <p>Are you sure about this action ?</p>
      </template>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          class="tt-button"
          @click="
            deletePlace();
            ok();
          "
        >
          Delete
        </b-button>
        <b-button variant="danger" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import { store } from "../store";

export default {
  name: "Place",
  data() {
    return {
      selectedPlace: ""
    };
  },
  props: {
    limit: {
      type: Boolean
    }
  },
  mounted() {
    this.$store.dispatch("place/getPlacesAction");
  },
  created() {
    this.$root.$on("successDelete", () => {
      this.successS = true;
    });
  },
  computed: {
    ...mapState({
      savedPlaces: state => state.place.all,
      success: state => state.place.actionSuccessMsg,
      error: state => state.place.actionErrorMsg
    }),
    deletingStatus() {
      return this.error || this.success;
    }
  },
  methods: {
    deletePlace() {
      this.selectedPlace["is_synced"] = false;
      this.selectedPlace["status"] = 2;
      this.$store.commit("place/markForDeletion", this.selectedPlace);
      this.$store.dispatch("place/getPlacesAction");
      store.commit("sync/getUnsyncedRecords");
    },
    editPlace(place) {
      if (this.$route.name === "edit-place") {
        alert("Please do save the current edited place first");
      } else {
        this.$router.push({
          name: "edit-place",
          params: { editablePlace: place }
        });
      }
      return true;
    }
  },
  watch: {
    limit: function(value) {
      value === true ? this.savedPlaces.slice(0, 10) : this.savedPlaces;
    },
    deletingStatus: function() {
      this.$store.commit("place/clearMes");
    }
  }
};
</script>

<style scoped>
.btn-tt-bg {
  background-color: #85c4cc !important;
}
</style>
